<app-configurator />
<div
  class="bg-surface-50 loginWrap dark:bg-surface-950 flex items-center justify-center min-h-screen min-w-[100vw] overflow-hidden">
  <div class="flex flex-col items-center justify-center">

    <!-- LOGIN FORM -->
    <form style="padding: 0.3rem">
      <div class="w-full bg-surface-0 dark:bg-surface-900 sm:px-20 loginBox">
        <div class="w-full sm:w-[480px] bg-surface-0 dark:bg-surface-900 p-8 rounded">
          <div class="text-center mb-8">
            <h1>Login</h1>
            <p>
              The CARDIO4Cities Simulator is a powerful, data-driven,<br />
              strategic tool that helps cities transform their <br />population's heart health at scale.
            </p>
          </div>
          <p-button label="Sign in with Azure AD B2C" (click)="goToDashboard()" [disabled]="signingIn"
            styleClass="w-full">
          </p-button>

        </div>





      </div>
    </form>

  </div>

  <div class="poweredBy">
    <p>Powered by Novartis Foundation</p>
  </div>
</div>